export default {
  apiKey: "AIzaSyA8qeVvXhRvw3rmztLotFfWKWGsm3cR1D4",
  authDomain: "edemdance2.firebaseapp.com",
  projectId: "edemdance2",
  storageBucket: "edemdance2.appspot.com",
  messagingSenderId: "1089768832280",
  appId: "1:1089768832280:web:2bad41fe47a3a9d049f26d",
  measurementId: "G-G0H77TD35G"
};